import React from 'react';
import Icon from '../../../components/AppIcon';

const CoachingModules = () => {
  const modules = [
    {
      icon: "Target",
      name: "Daily Drill",
      description: "Your personalized daily scenario to practice and improve core sales skills.",
      color: "var(--color-primary)"
    },
    {
      icon: "Shield",
      name: "Objection Dojo",
      description: "Master handling common objections specific to your industry with AI feedback.",
      color: "var(--color-accent)"
    },
    {
      icon: "FileText",
      name: "Script Lab",
      description: "Generate professional scripts for SMS, email, and calls based on your situations.",
      color: "var(--color-secondary)"
    }
  ];

  return (
    <div className="mb-12 px-4">
      <h2 className="text-2xl font-bold text-foreground text-center mb-8">
        Your Coaching Modules
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
        {modules?.map((module, index) => (
          <div
            key={index}
            className="bg-card rounded-2xl p-6 border border-border hover:shadow-elevated transition-all duration-300 group"
          >
            <div
              className="w-16 h-16 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300"
              style={{ backgroundColor: `${module.color}15` }}
            >
              <Icon name={module.icon} size={32} color={module.color} />
            </div>
            <h3 className="text-xl font-bold text-foreground mb-3">
              {module.name}
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {module.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoachingModules;